import * as serviceWorker from "./serviceWorker";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";
import {
  setLoginFlag,
  setLoginUser,
  setCountry,
  setLoginUserType,
} from "./redux/actions/login/loginAction";
import {
  setDirection,
  setLanguage,
} from "./redux/actions/languageDirection/languageDirectionAction";

import "./i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "./index.scss";
import "./assets/scss/style.css";
import "./assets/css/responsive.css";
import { history } from "./app/AppRouter";
import Spinner from "./components/spinner/spinner";
import ReduxToastr from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { getNotifications, subscribeToMember } from "./services/socketInstance";
import i18n from "./i18n";

//app router
const LazyApp = lazy(() => import("./app/AppRouter"));

const jsx = (
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <LazyApp />
      <ReduxToastr
        timeOut={4000} // move this to constant.js
        className={"direction-rtl"}
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
    </Suspense>
  </Provider>
);

let hasRendered = false;
const renderApp = async () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById("root"));
    hasRendered = true;
  }
};

serviceWorker.unregister();

const renderLogin = () => {
  store.dispatch(setLoginFlag(false));
  renderApp();

  if (
    window.location.pathname === "/reset-password" ||
    window.location.pathname === "/reset-password"
  ) {
  } else {
    // history.push('/login');
  }
};

try {
  if (
    window.location.pathname === "/connect-to-fit/website/reset-password" ||
    window.location.pathname === "/connect-to-fit/website/reset-password/"
  ) {
    localStorage.removeItem("connectToFitWebsiteUser");
    renderApp();
  }
  const login = localStorage.getItem("connectToFitWebsiteUser");
  let language = localStorage.getItem("language");
  if (language) {
    i18n.changeLanguage(language);
    store.dispatch(setLanguage(language));
    store.dispatch(setDirection(`${language === "en" ? "ltr" : "rtl"}`));
  }
  let country = localStorage.getItem("country");
  if (country) {
    store.dispatch(setCountry(country));
  }
  if (login) {
    const loginObject = JSON.parse(login);
    store.dispatch(setLoginUser(loginObject));
    store.dispatch(setLoginFlag(true));
    subscribeToMember(`${loginObject.id}M`);
    store.dispatch(setLoginUserType(loginObject.loginType));
    renderApp();
    if (
      window.location.pathname === "/connect-to-fit/website/" ||
      window.location.pathname === "/connect-to-fit/website"
    ) {
      history.push("/dashboard");
    }
  } else {
    renderLogin();
    // history.push('/login');
  }
} catch (e) {
  renderLogin();
}
